import { useState } from "react"
import { showToast } from "utils/swalToast"

import { Turnstile } from "@marsidev/react-turnstile"

import { useNavigate } from "react-router-dom"
import config from "config"
// @mui material components
import Card from "@mui/material/Card"

// Material Dashboard 2 React components
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDInput from "components/MDInput"
import MDButton from "components/MDButton"

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout"

// Images
import defaultBgImage from "assets/images/background.webp"
import defaultLogo from "assets/images/logo.svg"
import useBrandLogo from "hooks/useBrandLogo"
import useBackgroundImage from "hooks/useBackgroundImage"
import { Icon } from "@mui/material"

function Cover() {
  const brandLogo = useBrandLogo(defaultLogo)
  const bgImage = useBackgroundImage(defaultBgImage)
  const [email, setEmail] = useState("")
  const [error, setError] = useState("") // State for error message
  const [captchaValue, setCaptchaValue] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const navigate = useNavigate()

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value)
  }

  const handleSubmit = async () => {
    if (!captchaValue) {
      setError("Por favor, complete el CAPTCHA antes de continuar.")
      return
    }

    setIsLoading(true)
    setError("")

    try {
      const response = await fetch(
        `${config.api.baseURL}/security-tokens/generate?email=${encodeURIComponent(email)}`,
        { method: "POST" }
      )

      if (response.ok) {
        await showToast({
          title: "Hemos enviado un correo electrónico para continuar con el restablecimiento de su acceso. Verifique su bandeja de entrada.",
          icon: "success",
        })

        // Limpiar formulario
        setEmail("")
        setCaptchaValue(null)
        navigate("/authentication/sign-in")
      } else {
        const errorData = await response.text()
        setError(errorData || "Error en el servidor, intente nuevamente.")
      }
    } catch (error) {
      console.error(error)
      setError("No se pudo conectar al servidor. Verifique su conexión.")
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <BasicLayout image={bgImage}>
      <MDBox display="flex" justifyContent="center" alignItems="center" height="100vh">
        <Card style={{ width: "600px", border: "1px solid #DAD9D9" }}>
          <MDBox
            variant="gradient"
            bgColor="primary"
            borderRadius="lg"
            coloredShadow="info"
            mx={2}
            mt={-3}
            p={2}
            mb={1}
            textAlign="center"
          >
            <MDBox component="img" src={brandLogo} alt="logo" width="40%" mt={1} />
            <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
              Portal de monitoreo
            </MDTypography>
            <MDTypography variant="h6" fontWeight="medium" color="white" mt={1}>
              Restablecer Contraseña
            </MDTypography>
          </MDBox>
          <MDBox pt={4} pb={3} px={3}>
            <MDBox component="form" role="form">
              <MDBox mb={2}>
                <MDInput
                  type="text"
                  label="Correo Electronico"
                  fullWidth
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </MDBox>
              <MDBox mb={2}>
                <Turnstile
                  siteKey={config.turnstileSiteKey}
                  onSuccess={handleCaptchaChange}
                  onExpire={() => setCaptchaValue(null)}
                  onError={() => setCaptchaValue(null)}
                />
              </MDBox>
              <MDBox mt={2} mb={1} display="flex" justifyContent="space-between" gap={1}>
                <MDButton
                  variant="gradient"
                  color="secondary"
                  type="button"
                  onClick={() => navigate("/authentication/sign-in")}
                  style={{ flex: 1 }}
                >
                  <Icon>arrow_back_ios</Icon>Volver
                </MDButton>
                <MDButton
                  variant="gradient"
                  color="primary"
                  type="button"
                  style={{ flex: 1 }}
                  onClick={handleSubmit}
                  disabled={isLoading}
                >
                  {isLoading ? "Enviando..." : "Restablecer"}
                </MDButton>
              </MDBox>
              {error && (
                <MDBox mt={2} textAlign="center">
                  <MDTypography variant="caption" color="error">
                    {error}
                  </MDTypography>
                </MDBox>
              )}
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
    </BasicLayout>
  )
}

export default Cover


